<div class="dialog-container">
      <app-mat-spinner-overlay [overlay]="true" *ngIf="loading"></app-mat-spinner-overlay>
  <div class="dialog-header">
    <h2>Logs das Macros</h2>
    <button mat-icon-button [mat-dialog-close]="null" class="close-button" matTooltip="Fechar diálogo">
      <mat-icon matTooltip="Fechar diálogo">close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">

    <mat-accordion>
      <mat-expansion-panel expanded="true">
        <mat-expansion-panel-header>
          <mat-panel-title>
            Filtrar Logs
          </mat-panel-title>
        </mat-expansion-panel-header>

        <div class="row" [formGroup]="filterForm">
          <div class="col-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Macro</mat-label>
              <input matInput formControlName="master" placeholder="Filtrar por Macro" />
            </mat-form-field>
          </div>

          <div class="col-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Usuário</mat-label>
              <input matInput formControlName="usuario" placeholder="Filtrar por usuário" />
            </mat-form-field>
          </div>
          <div class="col-2">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Usuário Afetado</mat-label>
              <input matInput formControlName="usuarioAfetado" placeholder="Filtrar por usuário afetado" />
            </mat-form-field>
          </div>

          <div class="col-3">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Data Início/Fim</mat-label>
              <mat-date-range-input [rangePicker]="picker">
                <input matStartDate placeholder="00/00/0000" formControlName="dataHoraIncicio">
                <input matEndDate placeholder="00/00/0000" formControlName="dataHoraFim">
              </mat-date-range-input>
              <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
              <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
          </div>

          <div class="col-3 d-flex gap-2 btns-busca">
              <button mat-flat-button color="accent" type="button" (click)="buscar()">
                Consultar
                <mat-icon>search</mat-icon>
              </button>
              <button mat-flat-button type="button" (click)="clearFilter()">
                Limpar Filtro
                <mat-icon>delete</mat-icon>
              </button>
          </div>
        </div>

      </mat-expansion-panel>
    </mat-accordion>

    <div class="row mt-2 mb-2">
      <div class="col d-flex justify-content-end">
        <button mat-flat-button type="button" (click)="exportToExcel()">
          <mat-icon>description</mat-icon>
          <span>Exportar Excel</span>
        </button>
      </div>
    </div>

    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8 mt-2 w-100">

          <ng-container matColumnDef="tipoAcao">
            <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
            <td mat-cell *matCellDef="let log">
            <mat-icon>{{ getTipoIcon(log.tipoAcao ) }}</mat-icon>
            </td>
          </ng-container>
      <ng-container matColumnDef="master">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Macro</th>
        <td mat-cell *matCellDef="let log">{{ log.master }}</td>
      </ng-container>
      <ng-container matColumnDef="usuario">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuário</th>
        <td mat-cell *matCellDef="let log">{{ log.usuario }}</td>
      </ng-container>

      <ng-container matColumnDef="usuarioAfetado">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Usuário Afetado</th>
        <td mat-cell *matCellDef="let log">{{ log.usuarioAfetado }}</td>
      </ng-container>

      <ng-container matColumnDef="acao">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Ação</th>
        <td mat-cell *matCellDef="let log">{{ log.acao }}</td>
      </ng-container>
      <ng-container matColumnDef="dataHora">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Data/Hora</th>
        <td mat-cell *matCellDef="let log">{{ log.dataHora | date:'dd/MM/yyyy HH:mm' }}</td>
      </ng-container>
      <ng-container matColumnDef="detalhes">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Detalhes</th>
        <td mat-cell *matCellDef="let log" [matTooltip]="log.detalhes" matTooltipPosition="above" class="detalhes-cell">{{ log.detalhes }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let log; columns: displayedColumns;" [ngClass]="getRowClass(log.tipoAcao)"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 25,50,100]" showFirstLastButtons></mat-paginator>

  </div>
</div>
